exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".slide-avatar{width:30px;height:30px;border-radius:50%;background-size:30px;background-position:center;margin:0 10px 0 0}", ""]);

